var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CategoryBioLayout',{attrs:{"label":_vm.label,"category-info":_vm.author,"prev-route-link":_vm.prevRouteLink,"books-counter":_vm.booksCounter}})
}
var staticRenderFns = []

export { render, staticRenderFns }